/* [BD Feat] JS for scroll feature blkock section */

const section = document.getElementById('scroll-feature-block-inner');
  const circleLines = document.getElementById('circle-lines');

  for (let i = 0; i < 30; i++) {
    const line = document.createElement('div');
    line.className = 'animation-line';
    line.style.setProperty('--i', i);
    circleLines.appendChild(line);
  }

  const lines = document.querySelectorAll('.animation-line');
  const totalSteps = 20;
  const contentSteps = 4;
  const stepsPerContent = totalSteps / contentSteps;
  let scrollStep = 0;
  let isLocked = false;

  window.addEventListener('wheel', scrollHandler, { passive: false });
  window.addEventListener('keydown', blockKeys, { passive: false });
  // window.addEventListener('touchmove', preventTouch, { passive: false });

  function scrollHandler(e) {
    if (!isLocked) return;

    e.preventDefault();
    const direction = e.deltaY > 0 ? 'down' : 'up';

    if (direction === 'down' && scrollStep < totalSteps) {
      scrollStep++;
    } else if (direction === 'up' && scrollStep > 0) {
      scrollStep--;
    }

    updateLines(scrollStep);
    updateContentStep(scrollStep);

    if (scrollStep === 0 || scrollStep === totalSteps) {
      unlockScroll();
    } else {
      lockScroll();
    }
  }

  function lockScroll() {
    isLocked = true;
  }

  function unlockScroll() {
    isLocked = false;
  }

  function updateLines(step) {
    const fillCount = Math.floor((step / totalSteps) * lines.length);
    lines.forEach((line, index) => {
      line.classList.toggle('filled', index < fillCount);
    });
  }

  function updateContentStep(step) {
    const stepIndex = Math.floor(step / stepsPerContent);
    const contentStepsList = document.querySelectorAll('.content-step');

    contentStepsList.forEach((el, index) => {
      if (index === contentStepsList.length - 1 && step === totalSteps) {
        el.classList.add('active');
      } else {
        el.classList.toggle('active', index === stepIndex);
      }
    });
  }

  function blockKeys(e) {
    const blocked = [32, 33, 34, 35, 36, 37, 38, 39, 40];
    if (blocked.includes(e.keyCode)) {
      e.preventDefault();
    }
  }

  function preventTouch(e) {
    e.preventDefault();
  }

  window.addEventListener('scroll', () => {
    const rect = section.getBoundingClientRect();
    const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;

    if (isInView && !isLocked) {
      lockScroll();
    } else if (!isInView && isLocked) {
      unlockScroll();
    }
  });